import { Link } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'
import { motion } from 'framer-motion'
import { ArrowRight, ArrowUpRight, ExternalLink } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { cases } from '@/data/cases'

export function Cases() {
  return (
    <>
      <Helmet>
        <title>Cases — i3 Solutions</title>
        <meta
          name="description"
          content="Projetos entregues pela i3 Solutions: SaaS multi-tenant, plataformas de logística, infra cloud, observabilidade e mais."
        />
        <link rel="canonical" href="https://i3solutions.tech/cases" />
      </Helmet>

      <section className="border-b border-border/30">
        <div className="container py-20 md:py-28">
          <div className="max-w-3xl">
            <div className="text-sm font-semibold tracking-wider text-primary uppercase mb-3">
              Cases
            </div>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight text-balance">
              Projetos reais com impacto real
            </h1>
            <p className="mt-6 text-lg text-muted-foreground text-pretty">
              Uma seleção de trabalhos recentes. Pra detalhes técnicos, arquitetura e métricas de
              impacto, marca um call.
            </p>
          </div>
        </div>
      </section>

      <section className="py-16 md:py-20">
        <div className="container space-y-8">
          {cases.map((c, i) => (
            <motion.article
              key={c.slug}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-50px' }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              className="group relative p-8 md:p-10 rounded-2xl border border-border/50 bg-card hover:border-primary/40 transition-colors"
            >
              <div className="grid md:grid-cols-3 gap-8">
                <div className="md:col-span-2">
                  <div className="flex flex-wrap items-center gap-3 mb-4">
                    <span className="text-xs px-2.5 py-1 rounded-full bg-primary/10 text-primary font-medium">
                      {c.industry}
                    </span>
                    <span className="text-xs text-muted-foreground">{c.year}</span>
                  </div>
                  <h2 className="text-2xl md:text-3xl font-bold tracking-tight mb-3">{c.title}</h2>
                  <p className="text-muted-foreground text-pretty mb-4">{c.description}</p>
                  {c.url && (
                    <a
                      href={c.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center gap-1.5 text-sm text-brand-cyan hover:text-brand-cyan/80 mb-6 font-medium"
                    >
                      Visitar site <ExternalLink className="size-3.5" />
                    </a>
                  )}

                  <ul className="space-y-2 mb-6">
                    {c.highlights.map((h) => (
                      <li key={h} className="flex items-start gap-2 text-sm">
                        <ArrowUpRight className="size-4 text-primary mt-0.5 shrink-0" />
                        <span>{h}</span>
                      </li>
                    ))}
                  </ul>
                </div>

                <div className="md:border-l md:border-border/50 md:pl-8">
                  <div className="text-xs font-semibold tracking-wider text-muted-foreground uppercase mb-3">
                    Stack
                  </div>
                  <div className="flex flex-wrap gap-2">
                    {c.stack.map((tech) => (
                      <span
                        key={tech}
                        className="text-xs px-2 py-1 rounded border border-border/50 bg-background"
                      >
                        {tech}
                      </span>
                    ))}
                  </div>
                  <div className="text-xs text-muted-foreground mt-4">
                    Cliente:{' '}
                    <span className="text-foreground font-medium">{c.client}</span>
                  </div>
                </div>
              </div>
            </motion.article>
          ))}
        </div>
      </section>

      <section className="py-16">
        <div className="container max-w-2xl text-center">
          <h2 className="text-2xl md:text-3xl font-bold">Seu case pode ser o próximo</h2>
          <p className="mt-3 text-muted-foreground">
            Conta o problema que a gente vê se faz sentido trabalhar junto.
          </p>
          <Button asChild size="lg" className="mt-6">
            <Link to="/contato">
              Conversar com a gente <ArrowRight className="size-4" />
            </Link>
          </Button>
        </div>
      </section>
    </>
  )
}
